import { FETCH_PREVIEW_KEY, FETCH_TEMPLATE, FETCH_THEME_DEPENDENTS } from './ActionTypes';
import * as themeConnectionsClient from '../api/ThemeConnectionsClient';
import { getThemePath } from '../selectors/themeSelectors';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import * as DependentAssetTypes from '../constants/DependentAssetTypes';
const fetchDependentTemplatesRequested = dependentType => ({
  type: FETCH_THEME_DEPENDENTS,
  meta: {
    dependentType
  },
  requestStatus: RequestStatusTypes.PENDING
});
const fetchDependentTemplatesSucceeded = (dependentType, payload) => ({
  type: FETCH_THEME_DEPENDENTS,
  meta: {
    dependentType
  },
  payload,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const fetchDependentTemplatesFailed = (dependentType, error) => ({
  type: FETCH_THEME_DEPENDENTS,
  error: true,
  meta: {
    dependentType
  },
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const fetchDependentTemplates = () => (dispatch, getState) => {
  const dependentType = DependentAssetTypes.EXTENSION_RESOURCE;
  const state = getState();
  const themePath = getThemePath(state);
  dispatch(fetchDependentTemplatesRequested(dependentType));
  return themeConnectionsClient.fetchThemeTemplates(themePath).then(result => {
    dispatch(fetchDependentTemplatesSucceeded(dependentType, result));
    return result;
  }, error => {
    dispatch(fetchDependentTemplatesFailed(dependentType, error));
    return Promise.reject(error);
  });
};
const fetchTemplateRequested = templatePath => ({
  type: FETCH_TEMPLATE,
  meta: {
    templatePath
  },
  requestStatus: RequestStatusTypes.PENDING
});
const fetchTemplateSucceeded = (templatePath, payload) => ({
  type: FETCH_TEMPLATE,
  meta: {
    templatePath
  },
  payload,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const fetchTemplateFailed = (templatePath, error) => ({
  type: FETCH_TEMPLATE,
  error: true,
  meta: {
    templatePath
  },
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const fetchTemplate = templatePath => dispatch => {
  dispatch(fetchTemplateRequested(templatePath));
  return themeConnectionsClient.fetchTemplate(templatePath).then(result => {
    dispatch(fetchTemplateSucceeded(templatePath, result));
    return result;
  }, error => {
    dispatch(fetchTemplateFailed(templatePath, error));
    return Promise.reject(error);
  });
};
const fetchDependentPagesRequested = dependentType => ({
  type: FETCH_THEME_DEPENDENTS,
  meta: {
    dependentType
  },
  requestStatus: RequestStatusTypes.PENDING
});
export const fetchDependentPagesSucceeded = (dependentType, result) => ({
  type: FETCH_THEME_DEPENDENTS,
  meta: {
    dependentType,
    total: result.total,
    offset: result.offset,
    limit: result.limit
  },
  payload: result.objects,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const fetchDependentPagesFailed = (dependentType, error) => ({
  type: FETCH_THEME_DEPENDENTS,
  error: true,
  meta: {
    dependentType
  },
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const fetchDependentPages = () => (dispatch, getState) => {
  const dependentType = DependentAssetTypes.PAGE;
  const state = getState();
  const themePath = getThemePath(state);
  dispatch(fetchDependentPagesRequested(dependentType));
  return themeConnectionsClient.fetchThemePages(themePath).then(result => {
    dispatch(fetchDependentPagesSucceeded(dependentType, result));
    return result;
  }, error => {
    dispatch(fetchDependentPagesFailed(dependentType, error));
    return Promise.reject(error);
  });
};
const fetchContentPreviewKeyRequested = pageId => ({
  type: FETCH_PREVIEW_KEY,
  meta: {
    pageId
  },
  requestStatus: RequestStatusTypes.PENDING
});
const fetchContentPreviewKeySucceeded = (pageId, payload) => ({
  type: FETCH_PREVIEW_KEY,
  meta: {
    pageId
  },
  payload,
  requestStatus: RequestStatusTypes.SUCCEEDED
});
const fetchContentPreviewKeyFailed = (pageId, error) => ({
  type: FETCH_PREVIEW_KEY,
  error: true,
  meta: {
    pageId
  },
  payload: error,
  requestStatus: RequestStatusTypes.FAILED
});
export const fetchContentPreviewKey = pageId => dispatch => {
  dispatch(fetchContentPreviewKeyRequested(pageId));
  themeConnectionsClient.fetchContentPreviewKey(pageId).then(result => {
    dispatch(fetchContentPreviewKeySucceeded(pageId, result));
  }, error => {
    dispatch(fetchContentPreviewKeyFailed(pageId, error));
  }).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};